import { FC } from 'react';
import {
  Search as SearchIcon,
  Checkmark as CheckmarkIcon,
  SettingsAdjust,
} from '@carbon/react/icons';
import type { AuditTimelineRow } from './types';
import { formatMs } from './formatters';
import style from './audit-log.module.scss';

const toolIcon = (toolName: string) => {
  if (/search/i.test(toolName)) return <SearchIcon size={16} />;
  if (/suggest|match|score/i.test(toolName))
    return <SettingsAdjust size={16} />;
  if (/confirm|finaliz/i.test(toolName)) return <CheckmarkIcon size={16} />;
  return <SettingsAdjust size={16} />;
};

export const TimelineList: FC<{ rows: AuditTimelineRow[] }> = ({ rows }) => {
  if (rows.length === 0)
    return <p className={style.muted}>No timeline entries.</p>;
  return (
    <div className={style.toolCalls}>
      {rows.map((r) => (
        <div key={`${r.toolName}-${r.callNumber}`} className={style.toolCall}>
          <div className={style.toolCallIcon}>{toolIcon(r.toolName)}</div>
          <div className={style.toolCallBody}>
            <p className={style.toolCallName}>
              {r.toolName} <span>#{r.callNumber}</span>
            </p>
            <p className={style.toolCallDesc}>
              Offset {formatMs(r.offsetMs)} · Duration {formatMs(r.durationMs)}
            </p>
            {r.success === true && (
              <p
                className={`${style.toolCallDetail} ${style.toolCallDetailHighlight}`}
              >
                Success
              </p>
            )}
            {r.success === false && (
              <p
                className={`${style.toolCallDetail} ${style.toolCallDetailError}`}
              >
                Failed{r.errorMessage ? ` — ${r.errorMessage}` : ''}
              </p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
